import Vue from 'vue'
import VueRouter from 'vue-router'
const Login = () => import('../views/login.vue')
const Emotion = () => import('../views/emotion.vue')
const Serveice = () => import('../views/service.vue')
const whiteList = () => import('../views/white-list.vue')
const My = () => import('../views/my.vue')
const Qa = () => import('../components/qa.vue')
const History = () => import('../components/history.vue')
const HistoryDetails = () => import('../components/history-details.vue')
const Report = () => import('../components/report.vue')
const NowEmotion = () => import('../components/now-emotion.vue')
const NowStress = () => import('../components/now-stress.vue')
const NowTired = () => import('../components/now-tired.vue')
const TestMain = () => import('../components/test-main.vue')
const ServiceRecord = () => import('../components/service-record.vue')
const Health = () => import('../components/health.vue')
const EditorUser = () => import('../components/editor-user.vue')
const BindEquipment = () => import('../components/bind-equipment.vue')
const UnbindEquipment = () => import('../components/unbind-equipment.vue')
const Feedback = () => import('../components/feedback.vue')
const FeedbackRecord = () => import('../components/feedback-record.vue')
const FeedbackDetails = () => import('../components/feedback-details.vue')
const TrainMain = () => import('../components/train-main.vue')
const TrainReport = () => import('../components/train-report.vue')
const TestReportA = () => import('../components/test-report-a.vue')
const TestReportB = () => import('../components/test-report-b.vue')
const TestList = () => import('../components/test-list.vue')
const KnowledgeMore = () => import('../components/knowledge-more.vue')
const KnowledgeA = () => import('../components/knowledge-a.vue')
const KnowledgeB = () => import('../components/knowledge-b.vue')
const KnowledgeC = () => import('../components/knowledge-c.vue')
const KnowledgeD = () => import('../components/knowledge-d.vue')
const KnowledgeE = () => import('../components/knowledge-e.vue')
const KnowledgeF = () => import('../components/knowledge-f.vue')
const KnowledgeDetails = () => import('../components/knowledge-details.vue')
const TestMainCopy = () => import('../components/test-main-copy.vue')
const TestReportACopy = () => import('../components/test-report-a-copy.vue')
const TestReportBCopy = () => import('../components/test-report-b-copy.vue')
const Secretary = () => import('../components/list-secretary.vue')
const Datemotion = () => import('../components/date_emotion.vue')
const Shareuser = () => import('../components/share_user.vue')
const SelsctEquipment = () => import('../components/select-equipment.vue')
const Freedomtrain = () => import('../components/freedom-train.vue')
//彼岸新增页面
const TestDetails = () => import('../tview/test-details.vue')
const TestReportC = () => import('../tview/test-report-c.vue')
const TestReportD = () => import('../tview/test-report-d.vue')
const Service = () => import('../tview/service.vue')
const TestAll = () => import('../tview/test-all.vue')
const MeditationList = () => import('../tview/meditation-list.vue')
const NoiseList = () => import('../tview/noise-list.vue')
const MeditationAudio = () => import('../tview/meditation-audio.vue')
const MeditationReport = () => import('../tview/meditation-report.vue')
const MeditationVideo = () => import('../tview/meditation-video.vue')
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

const routes = [{
		path: '/login',
		name: 'login',
		meta: {
			index: 1,
			title: '登录'
		},
		component: Login
	},
	{
		path: '/',
		name: 'emotion',
		meta: {
			index: 2,
			title: '情绪识别'
		},
		component: Emotion
	},
	{
		path: '/now-emotion',
		name: 'now-emotion',
		meta: {
			index: 3,
			title: '识别报告'
		},
		component: NowEmotion
	},
	{
		path: '/now-stress',
		name: 'now-stress',
		meta: {
			index: 4,
			title: '识别报告'
		},
		component: NowStress
	},
	{
		path: '/now-tired',
		name: 'now-tired',
		meta: {
			index: 5,
			title: '识别报告'
		},
		component: NowTired
	},
	{
		path: '/service',
		name: 'service',
		meta: {
			index: 6,
			title: '心理服务'
		},
		component: Serveice
	},
	{
		path: '/my',
		name: 'my',
		meta: {
			index: 7,
			title: '我的'
		},
		component: My
	},
	{
		path: '/qa',
		name: 'qa',
		meta: {
			index: 8,
			title: '关于情绪识别'
		},
		component: Qa
	},
	{
		path: '/history',
		name: 'history',
		meta: {
			index: 9,
			title: '识别历史'
		},
		component: History
	},
	{
		path: '/history-details',
		name: 'history-details',
		meta: {
			index: 10,
			title: '识别详情'
		},
		component: HistoryDetails
	},
	{
		path: '/report',
		name: 'report',
		meta: {
			index: 11,
			title: '识别报告'
		},
		component: Report
	},
	{
		path: '/test-main',
		name: 'test-main',
		meta: {
			index: 12,
			title: '测评'
		},
		component: TestMain
	},
	{
		path: '/service-record',
		name: 'service-record',
		meta: {
			index: 13,
			title: '服务记录'
		},
		component: ServiceRecord
	},
	{
		path: '/health',
		name: 'health',
		meta: {
			index: 14,
			title: '生理健康'
		},
		component: Health
	},
	{
		path: '/editor-user',
		name: 'editor-user',
		meta: {
			index: 15,
			title: '编辑资料'
		},
		component: EditorUser
	},
	{
		path: '/bind-equipment',
		name: 'bind-equipment',
		meta: {
			index: 16,
			title: '绑定设备'
		},
		component: BindEquipment
	},
	{
		path: '/unbind-equipment',
		name: 'unbind-equipment',
		meta: {
			index: 17,
			title: '绑定设备'
		},
		component: UnbindEquipment
	},
	{
		path: '/feedback',
		name: 'feedback',
		meta: {
			index: 18,
			title: '问题反馈'
		},
		component: Feedback
	},
	{
		path: '/feedback-record',
		name: 'feedback-record',
		meta: {
			index: 19,
			title: '反馈记录'
		},
		component: FeedbackRecord
	},
	{
		path: '/feedback-details',
		name: 'feedback-details',
		meta: {
			index: 20,
			title: '反馈详情'
		},
		component: FeedbackDetails
	},
	{
		path: '/train-main',
		name: 'train-main',
		meta: {
			index: 21,
			title: '训练'
		},
		component: TrainMain
	},
	{
		path: '/train-report',
		name: 'train-report',
		meta: {
			index: 22,
			title: '训练报告'
		},
		component: TrainReport
	},
	{
		path: '/test-report-a',
		name: 'test-report-a',
		meta: {
			index: 23,
			title: '测评结果'
		},
		component: TestReportA
	},
	{
		path: '/test-report-b',
		name: 'test-report-b',
		meta: {
			index: 24,
			title: '测评结果'
		},
		component: TestReportB
	},
	{
		path: '/test-list',
		name: 'test-list',
		meta: {
			index: 25,
			title: '更多测评'
		},
		component: TestList
	},
	{
		path: '/knowledge-more',
		name: 'knowledge-more',
		meta: {
			index: 26,
			title: '心理知识'
		},
		component: KnowledgeMore
	},
	{
		path: '/knowledge-a',
		name: 'knowledge-a',
		meta: {
			index: 27,
			title: '心理知识'
		},
		component: KnowledgeA
	},
	{
		path: '/knowledge-b',
		name: 'knowledge-b',
		meta: {
			index: 28,
			title: '心理知识'
		},
		component: KnowledgeB
	},
	{
		path: '/knowledge-c',
		name: 'knowledge-c',
		meta: {
			index: 29,
			title: '心理知识'
		},
		component: KnowledgeC
	},
	{
		path: '/knowledge-d',
		name: 'knowledge-d',
		meta: {
			index: 30,
			title: '心理知识'
		},
		component: KnowledgeD
	},
	{
		path: '/knowledge-e',
		name: 'knowledge-e',
		meta: {
			index: 31,
			title: '心理知识'
		},
		component: KnowledgeE
	},
	{
		path: '/knowledge-f',
		name: 'knowledge-f',
		meta: {
			index: 32,
			title: '心理知识'
		},
		component: KnowledgeF
	},
	{
		path: '/knowledge-details',
		name: 'knowledge-details',
		meta: {
			index: 33,
			title: '心理知识'
		},
		component: KnowledgeDetails
	},
	{
		path: '/test-main-copy',
		name: 'test-main-copy',
		meta: {
			index: 34,
			title: '测评'
		},
		component: TestMainCopy
	},
	{
		path: '/test-report-a-copy',
		name: 'test-report-a-copy',
		meta: {
			index: 35,
			title: '测评结果'
		},
		component: TestReportACopy
	},
	{
		path: '/test-report-b-copy',
		name: 'test-report-b-copy',
		meta: {
			index: 36,
			title: '测评结果'
		},
		component: TestReportBCopy
	},
	{
		path: '/whiteList',
		name: 'whiteList',
		meta: {
			index: 37,
			title: '通讯白名单'
		},
		component: whiteList
	},
	{
		path: '/secretary',
		name: 'secretary',
		meta: {
			index: 38,
			title: '情绪小秘书'
		},
		component: Secretary
	},
	{
		path: '/datemotion',
		name: 'datemotion',
		meta: {
			index: 39,
			title: '情绪日记'
		},
		component: Datemotion
	},
	{
		path: '/shareuser',
		name: 'shareuser',
		meta: {
			index:40,
			title: '情绪分享'
		},
		component: Shareuser
	},{
		path: '/selectequipment',
		name: 'selectequipment',
		meta: {
			index:41,
			title: '绑定设备'
		},
		component: SelsctEquipment
	},{
		path: '/freedomtrain',
		name: 'freedomtrain',
		meta: {
			index:41,
			title: '自由练习'
		},
		component: Freedomtrain
	},{
		path: '/test-details',
		name: 'test-details',
		meta: {index: 46,title: '测评'},
		component: TestDetails
	},    
    {
		path: '/test-report-c',
		name: 'test-report-c',
		meta: {index: 47,title: '测评结果'},
		component: TestReportC
	},  
    {
		path: '/test-report-d',
		name: 'test-report-d',
		meta: {index: 48,title: '测评结果'},
		component: TestReportD
	},    
 //    {
	// 	path: '/service',
	// 	name: 'service',
	// 	meta: {index: 49,title: '心理服务'},
	// 	component: Service
	// },   
    {
		path: '/test-all',
		name: 'test-all',
		meta: {index: 50,title: '心理测评'},
		component: TestAll
	},  
    {
		path: '/meditation-list',
		name: 'meditation-list',
		meta: {index: 51,title: '冥想练习'},
		component: MeditationList
	},     
    {
		path: '/noise-list',
		name: 'noise-list',
		meta: {index: 52,title: '白噪音'},
		component: NoiseList
	},   
    {
		path: '/meditation-audio',
		name: 'meditation-audio',
		meta: {index: 53,title: '练习'},
		component: MeditationAudio
	},    
	{
		path: '/meditation-report',
		name: 'meditation-report',
		meta: {index: 54,title: '练习报告'},
		component: MeditationReport
	}, 
	{
		path: '/meditation-video',
		name: 'meditation-video',
		meta: {index: 56,title: '练习'},
		component: MeditationVideo
	}, 
]
const router = new VueRouter({
	// mode:'history',
	// base:process.env.BASE_URL,
	routes
})
export default router